<template>
  <div id="actions" class="actions-container" role="group">
    <div class="mb-2 action action-1">
      <a
        class="btn btn-primary w-100"
        :href=" API_SUFFIX + '/api/download/scenario/' + uuidId"
        @click.prevent="downloadScenario"
      >
        <i class="material-icons">save_alt</i>
      </a>
    </div>
    <div class="mb-2 action action-2">
      <button class="btn btn-primary w-100" @click="toggleFavourited(uuidId)">
        <span v-if="favouritedByUser">
          <i class="material-icons">star</i>
        </span>
        <span v-else>
          <i class="material-icons">star_border</i>
        </span>
      </button>
    </div>
  </div>
</template>

<script>
import scenService from "../services/scenarios.service";
export default {
  name: "ScenarioActions",
  data: function() {
    return {
      API_SUFFIX: process.env.VUE_APP_API_SUFFIX,
      favouritedByUser: this.isFavouritedByUser
    };
  },
  props: {
    uuidId: String,
    isFavouritedByUser: Boolean
  },
  methods: {
    toggleFavourited(scenarioId) {
      scenService.toggleFavouriteScenario(scenarioId).then(data => {
        this.favouritedByUser = data.toggled === "true";
        this.$parent.updateFavouriteScenariosList();
      });
    },
    downloadScenario() {
      scenService.downloadScenario(this.uuidId).then(data => {
        if (window.webkit) {
          let url = data.url;
          window.webkit.messageHandlers.scenarioimport.postMessage({
            url: data.url,
            fileName: data.fileName
          });
        } else {
          window.location = data.url;
        }
      });
    }
  }
};
</script>

<style scoped>
@media (max-width: 575.98px) {
  .actions-container {
    width: 100%;
    display: flex;
    flex-direction: row;
  }
  .action {
    width: 50% !important;
  }

  .action-1 {
    margin-right: 5px;
  }

  .action-2 {
    margin-left: 5px;
  }
}
</style>
